export const threeDCarouselMetaData = {
    isRepeatable: false
}
